import { render, staticRenderFns } from "./brandDictionaryEdit.vue?vue&type=template&id=dfcb3036&scoped=true&"
import script from "./brandDictionaryEdit.vue?vue&type=script&lang=js&"
export * from "./brandDictionaryEdit.vue?vue&type=script&lang=js&"
import style0 from "./brandDictionaryEdit.vue?vue&type=style&index=0&id=dfcb3036&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcb3036",
  null
  
)

export default component.exports